import CRMEditPartnerCodeForm from './CRMEditPartnerCodeForm';

export default CRMEditPartnerCodeForm;
